
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[hid]/about",
      function () {
        return require("private-next-pages/[hid]/about.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[hid]/about"])
      });
    }
  